"use client";

import AiLabel from "@/components/ai-label";
import { CustomCategory } from "@/components/category";
import PodcastPlayButton from "@/components/podcast-play-button";
import TeaserHeading from "@/components/teaser-heading";
import { Content } from "@/services/content/types";
import { createImageSizes, createImageUrl } from "@/utils/image";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";

type HorizontalProps = {
  episode: Content.PodcastEpisode;
  reverse?: boolean;
};

const Horizontal = (props: HorizontalProps) => {
  const image = props.episode.fields.teaserImage || props.episode.fields.image;
  const title =
    props.episode.fields.teaserTitle || props.episode.fields.title;
  const podcastShow = props.episode.fields["podcast-show"];

  return (
    <div>
      <Link
        href={`/podd/${props.episode.fields.slug}`}
        className="cursor-pointer group grid md:grid-cols-12 md:gap-8"
      >
        {image?.fields?.file?.url && (
          <div
            className={classNames("aspect-w-1 aspect-h-1 md:col-span-5 mb-4", {
              "order-2": props.reverse,
            })}
          >
            <Image
              fill
              src={createImageUrl(image.fields.file.url, { crop: "1:1" })}
              alt={image.fields.alt || ""}
              className="object-cover"
              sizes={createImageSizes({
                mobile: "33vw",
                tablet: "33vw",
                desktop: "33vw",
              })}
            />
            <AiLabel image={image} />
          </div>
        )}
        <div className="md:col-span-7">
          {podcastShow && (
            <CustomCategory color="Podd" name={podcastShow.fields.title} />
          )}
          {title && (
            <TeaserHeading
              text={title}
              className="text-2xl mb-4 font-semibold"
            />
          )}

          {props.episode.fields.media?.mediaUrl && (
            <PodcastPlayButton podcast={props.episode} />
          )}
        </div>
      </Link>
    </div>
  );
};

export default Horizontal;
